// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13ckR","left":"styles_left__18e39"};